export default "/images/logo-2.png?7bf689da6e304b6ea7201dd520420357";